import { render } from "./BaseProgressStep.vue?vue&type=template&id=5bd62334&scoped=true"
import script from "./BaseProgressStep.vue?vue&type=script&lang=js"
export * from "./BaseProgressStep.vue?vue&type=script&lang=js"

import "./BaseProgressStep.vue?vue&type=style&index=0&id=5bd62334&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd62334"]])

export default __exports__